import { render, staticRenderFns } from "./CommissionAssign.vue?vue&type=template&id=795e9ed0&scoped=true"
import script from "./CommissionAssign.vue?vue&type=script&lang=js"
export * from "./CommissionAssign.vue?vue&type=script&lang=js"
import style0 from "./CommissionAssign.vue?vue&type=style&index=0&id=795e9ed0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795e9ed0",
  null
  
)

export default component.exports